import React, { useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";

function ConfirmChangePassword(params) {

  const navigate = useNavigate();

  useEffect(() => {
    document.body.className = 'login';
  }, []);

  const gotoLogin = (e) => {
    navigate('/login');
  }

  return (
    <div className='panel-login'>
      <img src={process.env.PUBLIC_URL + '/static/imagens/logo.svg'} className='display--block margin--auto' alt='Logomarca' />
      
      <i className="bi bi-check-circle margin--auto text-center display--block color-primary" style={{fontSize: "96px", marginTop: "90px"}}></i>
      <sapn className='margin--auto text-center display--block'><b>Senha alterada com<br />Sucesso</b></sapn>
      <Button variant="primary" type="button" onClick={gotoLogin} className='margin--auto display--block' style={{ marginTop: "70px" }}>
        Fazer o Login Agora
      </Button>

    </div>
  );
};

export default ConfirmChangePassword;


